<page-context [page]="this">
  <article>
    <div class="row text-center">
      <div class="mx-auto text-left">
        <div>
          <h1>Forgot Password</h1>

          <div *ngIf="!token">
            <div *ngIf="requestSubmitted">
              <p>
                Your password change request was submitted.<br />
                Check your inbox for an email from us with instructions on resetting your password.
              </p>
              <div class="actions">
                <a class="btn btn-plain" (click)="close()" href="javascript:;">Close</a>
              </div>
            </div>
            <div *ngIf="!requestSubmitted">

              <p class="welcome">We all forget sometimes!</p>
              <error-message [host]="this"></error-message>
              <form (submit)="submit()">

                <div class="form-group">
                  <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div class="input-group-addon">
                      <mat-icon>mail</mat-icon>
                    </div>

                    <input errorHighlight type="text" class="form-control" id="email" name="email" placeholder="Email"
                      [(ngModel)]="email">
                  </div>
                </div>

                <p class="primary">An email will be sent with reset instructions.</p>
                <div class="actions">
                  <a class="btn btn-plain" (click)="backToLogin()" href="javascript:;">Cancel</a>
                  <button class="btn btn-primary">Continue</button>
                </div>
              </form>
            </div>
          </div>

          <div *ngIf="token">
            <div *ngIf="passwordChanged">
              <p>
                Welcome back {{user.display_name || user.first_name}}!<br />
                Your password was changed successfully and you are now logged in.
              </p>

              <div class="actions">
                <a class="btn btn-plain" (click)="close()" href="javascript:;">Close</a>
              </div>
            </div>
            <div *ngIf="!passwordChanged">
              <p class="welcome">Enter a new password below.</p>
              <error-message [host]="this"></error-message>
              <form (submit)="submit()">
                <div class="form-group">
                  <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div class="input-group-addon">
                      <mat-icon *ngIf="!strength">lock</mat-icon>
                      <mat-icon *ngIf="strength && strength.strengthCode == 'VERY_WEAK'">lock_open</mat-icon>
                      <mat-icon *ngIf="strength && strength.strengthCode == 'WEAK'">lock_open</mat-icon>
                      <mat-icon *ngIf="strength && strength.strengthCode == 'REASONABLE'">check_circle</mat-icon>
                      <mat-icon *ngIf="strength && strength.strengthCode == 'STRONG'">lock</mat-icon>
                      <mat-icon *ngIf="strength && strength.strengthCode == 'VERY_STRONG'">verified_user</mat-icon>
                    </div>

                    <input errorHighlight type="password" class="form-control" id="new-password" name="new-password"
                      (keyup)="checkStrength()" (change)="checkStrength(true)" placeholder="New Password"
                      [(ngModel)]="newPassword">
                  </div>
                </div>

                <div class="form-group">
                  <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div class="input-group-addon">
                      <mat-icon *ngIf="matches === null">lock</mat-icon>
                      <mat-icon *ngIf="matches === true">check</mat-icon>
                      <mat-icon *ngIf="matches === false">close</mat-icon>
                    </div>

                    <input errorHighlight type="password" class="form-control" id="confirm-password"
                      name="confirm-password" (change)="checkMatch()" placeholder="Confirm Password"
                      [(ngModel)]="confirmPassword">
                  </div>
                </div>

                <div class="strength-meter alert alert-info" *ngIf="!strength">
                  <mat-icon>info</mat-icon>
                  Strong passwords use a combination of upper and lower case letters, numbers and symbols
                  and are at least 8 characters. Passwords are case sensitive.
                </div>

                <div *ngIf="strength" class="strength-meter">
                  <div class="alert alert-danger" *ngIf="strength.strengthCode == 'VERY_WEAK'">
                    <mat-icon>lock_open</mat-icon>
                    Very weak
                  </div>
                  <div class="alert alert-danger" *ngIf="strength.strengthCode == 'WEAK'">
                    <mat-icon>lock_open</mat-icon>
                    Weak
                  </div>
                  <div class="alert alert-warning" *ngIf="strength.strengthCode == 'REASONABLE'">
                    <mat-icon>check_circle</mat-icon>
                    Reasonable
                  </div>
                  <div class="alert alert-success" *ngIf="strength.strengthCode == 'STRONG'">
                    <mat-icon>lock</mat-icon>
                    Strong
                  </div>
                  <div class="alert alert-info" *ngIf="strength.strengthCode == 'VERY_STRONG'">
                    <mat-icon>verified_user</mat-icon>
                    Too Strong!
                  </div>
                </div>

                <p class="primary">Remember: Never reuse or share your passwords!</p>
                <div class="actions">
                  <a class="btn btn-plain" (click)="backToLogin()" href="javascript:;">Cancel</a>
                  <button class="btn btn-primary">Reset</button>
                </div>
              </form>
            </div>
          </div>



        </div>
      </div>
    </div>
  </article>
</page-context>